export default "__VITE_ASSET__Dwxcfg7Z__"